import {MatchInfo, MatchInfoJson} from '/src/com/yext/listingslaunchstorm/js/data/matchinfo';

/**
 * @fileoverview Model representing the server response after requesting Google Matches
 *
 * @author Dave Sammel (dsammel@yext.com)
 */

export class GetGoogleMatchesResponse {
  /**
   * @param {{
   *  matches: !Array<MatchInfo>,
   * }} params
   */
  constructor(params) {
    /** @type {Array<MatchInfo>} */
    this.matches = params.matches;
  }

  /**
   * @param {GetGoogleMatchesResponseJson} json
   * @return {!GetGoogleMatchesResponse}
   */
  static fromJSON(json) {
    return new GetGoogleMatchesResponse({
      matches: json['matches'].map(match => MatchInfo.fromJSON(match)),
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  matches: !Array<MatchInfoJson>,
 * }}
 */
export var GetGoogleMatchesResponseJson;
